export default __webpack_public_path__ + "static/media/slider.8eb9f9c6.png";